import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {Lien} from '@app/titles/models/lien';
import {User} from '@ui/types/user';
import {Nzb} from '@app/titles/models/nzb';

export interface ResponseDownload extends BackendResponse {
  download_url: string;
  expires_at: string;
  model: Nzb;
}

export function useDownloadNzb(
  id: number,
  enabled: boolean,
  user?: User,
  token?: string,
) {
  return useQuery({
    queryKey: ['nzb', id],
    enabled,
    queryFn: () => fetchDownload(id, user, token),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

async function fetchDownload(id: number, user?: User, token?: string) {
  return await apiClient
    .post<ResponseDownload>(`nzb/${id}/get`, {token})
    .then(response => response.data);
}
